import template from './subcontract-project-view.html';
import controller from './subcontract-project-view.controller';

let subcontractProjectViewComponent = {
  restrict: 'E',
  bindings: {
    project: '<'
  },
  template,
  controller
};

export default subcontractProjectViewComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/project-details/views/subcontract-project-view/subcontract-project-view.component.js